import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { formatearNumeroEntero } from '../../funciones_globales/format';
import moment from 'moment';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormCon07 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            periodo: '',
            mes_opt: [],
            mes_sel: null,
            anioActual: null,

            fechaEnvio: null,
            //CONTROL SOBRE PANTALLA
            control: 0,
        };

        this.changeComponents = this.changeComponents.bind(this);
        this.changeYear = this.changeYear.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.generarDINARDAP = this.generarDINARDAP.bind(this);
    }

    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('08');
        let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
        let fechaHasta = fechaDesde.endOf('month');
        this.setState({fechaDesde: moment(fechaProceso, "DD/MM/YYYY"), fechaHasta: fechaHasta})
    }

    changeYear(){
        if(this.state.periodo!==''){
            let anio = formatearNumeroEntero(this.state.periodo);
            let fechaInf = formatearNumeroEntero(this.state.anioActual) - 3;

            if(anio>formatearNumeroEntero(this.state.anioActual)){
                this.setState({periodo: formatearNumeroEntero(this.state.anioActual)});
            }else if(anio===formatearNumeroEntero(this.state.anioActual)){
                this.setState({periodo: anio});
            }else if(anio >= fechaInf && anio <=formatearNumeroEntero(this.state.anioActual)){
                this.setState({periodo: anio});
            }else{
                this.setState({periodo: formatearNumeroEntero(this.state.anioActual)});
                alert("Sólo puede consultar información de los últimos 3 años.");
            }
        }
    }

    componentDidMount(){

        Promise.all([
            cargarCatalogos_Otros('MESES'), this.props.generar_LogAuditoriaIngresoForm('0807')
         ])
        .then(([meses]) => {
            let ArrayMeses = [];
            meses.forEach((MES)=>{
                
                if(MES.value !== '00'){
                    let item = {};
                    item.value = MES.value;
                    item.label = MES.label;
                    ArrayMeses.push(item);
                }
            })

            let fechaProceso = getFechaProcesoPorModulo('08').split('/');
            this.setState({ mes_opt: ArrayMeses, mes_sel: fechaProceso[1], periodo: fechaProceso[2], anioActual: fechaProceso[2]})
        })
        .catch((error )=>{
            alert(error.response?error.response.data.msg:error.message);
            this.setState({control: 1});
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0807');
    }

    //Consulta DB
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }

    //Boton Generar Respaldo
    generarRespaldo(){
        this.cargarObjetos(`/respaldo?periodo=${this.state.periodo}&mes=${this.state.mes_sel}&obj=cartera`).then((exist)=>{
            if(exist.exist===true){
                let msj = window.confirm('Existen un historial para este periodo y mes, ¿Sobreescribir?');
                if (msj){
                    this.genHistorial();
                }   
            }else{
                this.genHistorial();
            }
        })
        .catch((error)=>{
            alert("Ha ocurrido un error: " + error);
        });
    }

    //Boton Generar DINARDAP
    generarDINARDAP(){
        
        this.cargarObjetos(`/respaldo?periodo=${this.state.periodo}&mes=${this.state.mes_sel}&obj=cartera`).then((exist)=>{
            if(exist.exist===true){
                this.genDinardapText(); 
            }else{
                alert('No existe un historial para el periodo y mes seleccionado, generelo en "Formulario de cierre" antes de continuar')
            }
        })
        .catch((error)=>{
            alert("Ha ocurrido un error: " + error);
        });
    }

    genDinardapText(){
        let data = {};

        data.periodo = this.state.periodo;
        data.mes = this.state.mes_sel;

        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
            method: 'POST',
            url: '/dinardap/text',
            data,
            responseType: 'text'
        })
        .then((response)=>{
            this.props.cambiar_VisualizacionLoading(false);
            let dayEnd = moment(`01/${data.mes}/${data.periodo}`, 'DD/MM/YYYY').endOf("month").format('D'); 
            const url = window.URL.createObjectURL(new Blob([response.data],{type:'text/plain;charset=ansi'}));
            const link = document.createElement('a');
            link.href = url;
            if(response.status===200){
                link.setAttribute('download', '0992242175001'+ dayEnd + data.mes + data.periodo +'.txt');
            }else{
                link.setAttribute('download', 'ERRORES-' + data.mes + data.periodo +'.txt');
            }
            document.body.appendChild(link);
            link.click();
        })
        .catch((error)=>{
            this.props.cambiar_VisualizacionLoading(false);
            alert("Ha ocurrido un error: " + error);
        });
    }

    render(){
        return(
            <ContenedorForm porc_ancho={40}>
                <HeaderForm>
                    <TituloForm>Generación de DINARDAP</TituloForm>
                </HeaderForm>
                    <CuerpoForm>
                    <Row>                        
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='4'>
                            <LabelForm>Periodo:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='4'>
                            <InputText name='periodo' value={this.state.periodo} type="number" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.changeYear(value)}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_abajo='4'>
                            <LabelForm>Mes:</LabelForm>
                        </ContainerCol>                
                        <ContainerCol className='col-sm-4' margen_abajo='4'>
                            <ReactSelect options={ this.state.mes_opt } value={this.state.mes_sel} func_onChange={(value)=>{this.setState({mes_sel: value!==null?value.value:null})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <ContainerCol className='btn-group pull-right' margen_arriba='7'> 
                                <button type='button' className='btn btn-primary btn-sm' disabled={this.state.periodo===''|| this.state.mes_sel===null || this.state.control===1?true:false} onClick={this.generarDINARDAP}><i className="fa fa-cog" aria-hidden="true"/> Generar</button>
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </ContainerCol>
                        </ContainerCol>
                    </Row>
                    </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
return {puntoFacturacionSel: state.ventas.ptoFacturacionSel,
        permiso: state.sesion.valoresSesionForm.Permiso,
        usuario: state.sesion.valoresSesionForm.Usuario,
        IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
        departamento : state.sesion.valoresSesionForm.Departamento}
});
    
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                            cambiar_VisualizacionLoading }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCon07);